import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import CompetitionEntryForm from '../../../components/forms/CompetitionEntryForm';
import { useCompetitionEntryApi } from '../../../hooks/useCompetitionEntryApi';
import { useNavigate, useParams } from 'react-router-dom';
import { CompetitionEntryDTO } from '../../../services/apiClient';

const CompetitionEntryEdit: React.FC = () => {
  const { getById, edit } = useCompetitionEntryApi();
  const [entityData, setEntityData] = useState<CompetitionEntryDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Competition Entries', href: '/admin/competitionentries' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching CompetitionEntry data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await edit(id!, data);
      navigate('/admin/competitionentries');
    } catch (error) {
      console.error('Error updating CompetitionEntry:', error);
    } finally{
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/competitionentries"
      breadcrumbs={breadcrumbs}
      allowedRoles={['User']}
      requiredPermission='Manage.CompetitionEntry.Edit'
    >
        {entityData ? (
          <CompetitionEntryForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/competitionentries')}
            isLoading={isSubmitting}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default CompetitionEntryEdit;